<template>
  <div>
    <LeftListSupplier :pos="2"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="/suppliercenter-information" class="txt">企业信息</router-link>
          </li>
          <li class="li">
            <router-link to="/info-password" class="txt">修改密码</router-link>
          </li>
          <li class="li">
            <router-link to="/info-qualifications" class="txt">资质认证</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox1">
            <div class="g-titin1">个人头像</div>
            <div class="top">
              <div class="pic" v-if="form.avatar">
                <img :src="form.avatar" class="img" alt="" />
              </div>
              <div class="right">
                <div class="g-upbtn">
                  <pic-upload :show-file-list="false" list-type="text" v-model="form.avatar">
                  <div class="span" @click="form.avatar=''">选择图片</div>
                  </pic-upload>
                </div>
                <div class="info">
                  建议长宽1:1，不小于100px，JPG、PNG、GIF格式，小于300K。
                </div>
                <div class="desc">ID：{{ form.showId }}</div>
              </div>
            </div>
          </div>
          <div class="m-infobox1">
            <div class="g-titin1">单位logo</div>
            <div class="top">
              <div class="pic">
                <img v-if="form.companyLogo" :src="form.companyLogo" class="img" alt="" />
                <img v-else src="@/assets/images/logoNew.png" class="img" style="filter: grayscale(1);" alt="" />
              </div>
              <div class="right">
                <div class="g-upbtn">
                  <pic-upload :show-file-list="false" list-type="text" v-model="form.companyLogo">
                    <div class="span" @click="form.companyLogo=''">选择图片</div>
                  </pic-upload>
                </div>
                <div class="info">
                  建议长宽1:1，不小于100px，JPG、PNG、GIF格式，小于300K。
                </div>
              </div>
            </div>
          </div>
          <div class="m-infobox2">
            <div class="g-titin1">我的信息</div>
            <div class="m-fromin1">
              <form action="" onsubmit="return false">
                <div class="form js-form">
                  <div class="group group3">
                    <div class="txt"><span>*</span>姓名：</div>
                    <div class="inpbox">
                      <el-input  v-model="form.realname" class="inpt"></el-input>
                      <!-- <input type="text" value="唐庆伟 " class="inpt" /> -->
                    </div>
                  </div>
                  <div class="group group2">
                    <div class="txt"><span>*</span>性别：</div>
                    <div class="inpbox inpbox4">
                      <a-radio-group v-model="form.gender">
                        <a-radio value="男"> 男 </a-radio>
                        <a-radio value="女"> 女 </a-radio>
                      </a-radio-group>
                    </div>
                  </div>
                  <div class="group">
                    <div class="txt"><span>*</span>手机号：</div>
                    <div class="inpbox">
                      <el-input  v-model="form.mobile" :readonly="!mobileCanEdit" class="inpt"></el-input>
                      <!-- <input type="text" value="189105540654" class="inpt" /> -->
                    </div>
                    <div class="popbtn" v-if="mobileCanEdit" @click="showModal">更换绑定手机号</div>
                  </div>
                  <div class="group">
                    <div class="txt"><span>*</span>单位名称：</div>
                    <div class="inpbox inpbox1">
                      <el-input value=" " v-model="form.companyName" class="inpt"></el-input>
                      <!-- <input type="text" value="唐庆伟 " class="inpt" /> -->
                    </div>
                  </div>
                  <div class="group">
                    <div class="txt"><span>*</span>简称：</div>
                    <div class="inpbox inpbox1">
                      <el-input value=" " v-model="form.shortName" :maxlength="6" class="inpt" placeholder="请输入简称（6个字符以内）"></el-input>
                    </div>
                  </div>
                  <div class="group">
                    <div class="txt">通讯地址：</div>
                    <div class="inpbox inpbox2">
                      <el-input  v-model="form.address" class="inpt"></el-input>
                      <!-- <input
                        type="text"
                        value="北京华扬天博文化传播有限公司"
                        class="inpt"
                      /> -->
                    </div>
                  </div>
                  <div class="group group2">
                    <div class="txt">Email：</div>
                    <div class="inpbox inpbox3">
                      <el-input  v-model="form.email" class="inpt"></el-input>
                      <!-- <input
                        type="text"
                        value="tangqingwei1983@126.com "
                        class="inpt"
                      /> -->
                    </div>
                  </div>
                  <div class="group">
                    <div class="txt">微信绑定：</div>
                    <div v-if="$store.state.user.userInfo.wxweb_openid" class="inpbox inpbox3" @click="bindByWechat">
                      <img class="wechat" src="@/assets/images/wechat_mini.png"/>
                      <span style="color:  #188efc;cursor: pointer;">已绑定，点击重新绑定</span>
                    </div>
                    <div v-else class="inpbox inpbox3" @click="bindByWechat">
                      <img class="wechat" src="@/assets/images/wechat_mini.png"/>
                      <span style="color:  #188efc;cursor: pointer;">点击绑定</span>
                    </div>
                  </div>
                </div>
                <button class="g-btnsave" v-loading="saving" @click="save">保存</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <a-modal
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      :centered="true"
      :closable="false"
      :width="895"
    >
      <div class="m-popin1">
        <div class="tit">修改手机号</div>
        <form action="" onsubmit="return false">
        <div class="form">
          <div class="group">
            <div class="txt">原手机号</div>
            <div class="infobox">
              <el-input v-model="mobileForm.old" class="inpt" readonly></el-input>
              <!-- <input type="text" class="inpt" /> -->
            </div>
          </div>
          <div class="group">
            <div class="txt">新手机号</div>
            <div class="infobox">
              <el-input v-model="mobileForm.new" class="inpt"></el-input>
              <!-- <input type="text" class="inpt" /> -->
            </div>
          </div>
          <div class="group-code">
            <div class="txt1">短信验证码</div>
            <div class="infobox2">
              <div class="left">
                <el-input v-model="mobileForm.vercode" placeholder="请输入短信验证码" class="inpt"></el-input>
                <!-- <input type="text" placeholder="请输入短信验证码" class="inpt" name="" id="" /> -->
              </div>
              <div class="right">
                <button
                  :disabled="isCountingDown"
                  @click="getCaptcha"
                  class="code"
                >
                  获取验证码
                </button>
                <p v-if="isCountingDown" class="num">剩余{{ countdown }}秒</p>
              </div>
            </div>
           <button class="btn" @click="saveMobile">确认修改</button>
          <!-- <div class="info">注：修改成功后提示返回登录界面登录</div> -->
          </div>
        </div>
      </form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import PicUpload from "@/views/common/PicUpload.vue";
import {getApiRes} from "@/api/apiUtil";
import apiUserInfo from "@/api/userInfo";
export default {
  components: {
    LeftListSupplier,
    PicUpload,
  },
  data() {
    return {
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      // 单选
      value: 1,
      // 验证码
      isCountingDown: false, // 是否正在倒计时
      countdown: 60, // 倒计时秒数
      timer: null, // 定时器,
      mobileCanEdit: false,

      form: {
        id: 0,
        realname: "",
        mobile: "",
        companyName: "",
        shortName: '',
        address: "",
        email: "",
        avatar: '',
        companyLogo: '',
        gender: '男'
      },
      mobileForm: {
        old: '',
        new: '',
        vercode: ''
      },
      saving: false,
    };
  },
  computed: {},
  mounted() {
    // 读取用户信息
    Object.assign(this.form, this.$store.state.user.userInfo)
    this.mobileCanEdit = this.form.mobile ? false : true

    if(this.$route.query.tip === 'mobile'){
      this.$alert('请填写手机号，完善信息后保存，以完成微信登录绑定', '提示')
    }
  },
  methods: {
    async save(){
      if(this.saving) return
      if(!this.form.realname) return this.$message.error('请输入真实姓名')
      if(!this.form.gender) return this.$message.error('请选择性别')
      if(!this.form.mobile) return this.$message.error('请输入手机号')
      if(!this.form.companyName) return this.$message.error('请输入单位名称')
      if(!this.form.shortName) return this.$message.error('请输入单位简称')
      this.saving = true
      let re = await getApiRes(apiUserInfo.save(this.form))
      this.saving = false
      if(re.code==0){
        this.$store.commit('user/SET_USER_INFO', re.data)
        this.$message.success('保存成功')
      }
    },
    showModal() {
      this.mobileForm.old = this.form.mobile
      this.visible = true;
    },
    handleOk(){
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 验证码
    async getCaptcha() {
      if (this.isCountingDown) {
        return; // 如果正在倒计时，则不执行获取验证码操作
      }

      // 在这里执行获取验证码的操作，比如向服务器发送请求
      let re = await getApiRes(apiUserInfo.sendSmsCode(this.mobileForm.old), 0, 1,1,1)
      if(re.code!=0) return

      // 开始倒计时
      this.isCountingDown = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          // 倒计时结束，重置状态
          this.isCountingDown = false;
          this.countdown = 60;
          clearInterval(this.timer); // 清除定时器
        }
      }, 1000);
    },
    async saveMobile(){
      if(!this.mobileForm.new) return this.$message.error('请输入新手机号')
      if(!this.mobileForm.vercode) return this.$message.error('请输入短信验证码')

      let re = await getApiRes(apiUserInfo.saveMobile(this.mobileForm.new, this.mobileForm.vercode))
      if(re.code==0){
        this.$store.commit('user/SET_USER_INFO', re.data)
        this.$message.success('修改成功')
        this.visible = false
        // 重新读取用户信息
        Object.assign(this.form, re.data)
      }
    },
    bindByWechat(){
      // window.open('/user/login/wxwebLogin')
      window.location.href = '/user/login/wxwebBind'
      // console.log('1')
    },
  },
};
</script>

<style lang="scss" scoped></style>
